<input hidden="true" type="file" #fileElement accept="{{file_format}}" (change)="onLoaded($event)">

<button class="my-button" mat-button [matMenuTriggerFor]="menu"> 
    {{'filemenu.title' | translate}}<mat-icon>expand_more</mat-icon>
</button>
<mat-menu #menu="matMenu">
    <button mat-menu-item (click)="new()">{{'filemenu.new' | translate}}</button>
    <!--button mat-menu-item (click)="saveOnServer()" [disabled]="!authService.isAuthenticated">{{'filemenu.save' | translate}}</button-->
    <!--button mat-menu-item (click)="saveOnServer(true)" [disabled]="!authService.isAuthenticated">{{'filemenu.saveascopy' | translate}}</button-->
    <button *ngIf="labeledDataManager.modelType == 'numerical'" mat-menu-item (click)="load_from_csv()">{{'filemenu.load_csv' | translate}}</button>
    <button mat-menu-item (click)="load_from_json()">{{'filemenu.loadlocal' | translate}}</button>
    <button mat-menu-item (click)="save()">{{'filemenu.savelocal' | translate}}</button>
</mat-menu>
